import { createContext, useContext, useMemo } from 'react'

const ChatContext = createContext({
  chatMessages: [],
  sendMessage: () => {},
  users: {},
})

export const ChatContextProvider = ({
  activeUsers,
  chatMessages,
  children,
  groupWatch,
  sendMessage,
  userIsWatchingOnTV,
  onBack,
}) => {
  const users = useMemo(() => {
    const map = {}

    if (groupWatch.userList) {
      groupWatch.userList.forEach((user) => {
        map[user.memberId] = user
      })
    }

    return map
  }, [groupWatch.userList])

  const contextValue = useMemo(
    () => ({
      activeUsers,
      chatMessages,
      onBack,
      sendMessage,
      users,
      userIsWatchingOnTV,
    }),
    [chatMessages, sendMessage, users, activeUsers, userIsWatchingOnTV, onBack],
  )

  return <ChatContext.Provider value={contextValue}>{children}</ChatContext.Provider>
}

export const useChatContext = () => useContext(ChatContext)
